import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGUAGES, setLanguageOverride } from "../i18n";
import { useJobLang } from "../i18n/JobLangContext";

// Top-right language switcher for the candidate app: two buttons side by side
// (EN / 日本語). Shown ONLY for Japan-country jobs — non-Japan jobs are always
// English with no switcher. Picking a language sets a per-device override that
// sticks and overrides the job default.
const LanguageSwitcher = () => {
    const { i18n } = useTranslation();
    const { isJapanJob } = useJobLang();

    if (!isJapanJob) return null;

    const current = (i18n.resolvedLanguage || i18n.language || "en").slice(0, 2);

    return (
        <Switch role="group" aria-label={i18n.t("language")}>
            {SUPPORTED_LANGUAGES.map((l) => (
                <button
                    key={l.code}
                    type="button"
                    className={current === l.code ? "active" : ""}
                    aria-current={current === l.code ? "true" : undefined}
                    onClick={() => setLanguageOverride(l.code)}
                >
                    {l.short}
                </button>
            ))}
        </Switch>
    );
};

const Switch = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 2px;

  button {
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.6);
    color: #ffffff;
    font-size: 13px;
    font-weight: 600;
    line-height: 1;
    padding: 5px 9px;
    border-radius: 4px;
    cursor: pointer;
    white-space: nowrap;

    &.active {
      background: #ffffff;
      color: #2e7d32;
      border-color: #ffffff;
    }
  }
`;

export default LanguageSwitcher;
